import {
  Carousel,
  CreateType,
  DropdownType,
  SvgReload,
  SvgVerticalSplitter,
  TemplateDropDown,
} from '@ui-kit'
import {
  DASHBOARD,
  ENTITY_NAME,
  NAMESPACES,
  PERMISSION_ACCESSIBILITY,
  PERMISSION_MODULES,
  USER_PROFILE_CATEGORY,
  USER_PROFILES,
} from '../../utils/constants'
import { AppComponentProps } from '../../utils/types'
import DynamicLayoutTable from './dynamicLayoutTable'
import { useEffect, useMemo, useRef, useState } from 'react'
import {
  addToaster,
  CaseTileDataType,
  ClientProgramsMap,
  DashboardLayoutType,
  DashboardMetadata,
  dashboardPageableQueuesApi,
  DataTypeStore,
  ErrorResponseData,
  getCaseSummaryTileAPI,
  getLayoutDashboardAPI,
  getOldestWorkForAgentAPI,
  hideLoader,
  queueListingType,
  selectedCaseEntityReducer,
  SelectedClientProgramType,
  setProgramDropdown,
  showLoader,
} from '@app-store'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  fetchEntityIdByName,
  openNewWindow,
  permissionObject,
  programPermissionsObject,
} from '../../utils/helperFunctions'
import {
  isProgramAdmin,
  isReadOnlyUser,
  isSuperAdmin,
} from '../../utils/permission'
import {
  DYNAMIC_QUEUE_CONSTANTS,
  DYNAMIC_QUEUE_MESSAGES,
} from '../../constants/dynamicQueue'
import { AxiosError } from 'axios'
import { v4 as uuid } from 'uuid'
import _, { debounce, isEmpty } from 'lodash'
import { STRINGS } from '../../utils/strings'
import { FieldValues } from 'react-hook-form'
import { assignUnassignTasksWithCases } from '../../apis/entityData.api'
import InteractiveDashboard from './InteractiveDashboard'

export const DashboardPage: React.FC<AppComponentProps> = () => {
  const dispatch = useAppDispatch()
  const isInteractiveDashboard = true
  const user = useAppSelector((state: RootState) => state?.authUser?.user)
  const profileCatergoryId = useAppSelector(
    (state: RootState) => state?.authUser?.user?.profile_category_id
  )
  const userId = useAppSelector((state: RootState) => state?.authUser?.user?.id)
  const selectedTenantId = useAppSelector(
    (state: RootState) => state?.authUser?.selectedClientTenant?.id
  )
  const selectedTenantName = useAppSelector(
    (state: RootState) =>
      state?.authUser?.selectedClientTenant?.name_of_organization
  )
  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions.programPermissions
  )
  const programServices = useAppSelector(
    (state: RootState) => state.clientPermissions.programServices
  )
  const selectedQueue = useAppSelector(
    (state) => state?.queueCreation?.selectedQueue
  )
  const profile = useAppSelector(
    (state: RootState) => state?.authUser?.user?.profile
  )
  const lastCallRef = useRef<string>('')
  const lastCallRef_1 = useRef<string>('')
  const [selectedDashboard, setSelectedDashboard] = useState(
    DASHBOARD.AGENT_DASHBOARD
  )
  const [hasDashboardsPermission, setHasDashboardsPermission] =
    useState<boolean>()

  const selectedClientProgram = useAppSelector(
    (state: RootState) => state?.clientPrograms?.selectedClientPrograms
  )
  const allClientPrograms = useAppSelector(
    (state: RootState) => state?.clientPrograms?.allClientPrograms
  )

  const queueConfig = useAppSelector(
    (state: RootState) => state?.queueCreation?.children
  )

  const [hasTileData, setHasTileData] = useState<boolean>(false)

  const navigate = useNavigate()
  const location = useLocation()
  const [refetchKey, setRefetchKey] = useState<number>(0)
  const [isSupervisor, setIsSupervisor] = useState<boolean>(false)

  const [tableLayoutConfig, setTableLayoutConfig] = useState<
    DashboardLayoutType[]
  >([])

  const [programQueueOptions, setProgramQueueOptions] = useState<CreateType[]>(
    []
  )
  const [caseEntityId, setCaseEntityId] = useState<number>()

  const [tileConfig, setTileConfig] = useState<CaseTileDataType[]>([])

  const [hasData, setHasData] = useState<boolean>(true)

  const handleReloadButtonClick = () => {
    setRefetchKey(refetchKey + 1)
  }

  //gets ids and then caseSummary data & tableLayouts
  const fetchTileAndLayoutConfig = async (
    user_id: string,
    program_id: string,
    isSupervisor: boolean,
    selectedDashboard: string
  ) => {
    try {
      dispatch(showLoader())
      const response = await getLayoutDashboardAPI(
        (user_id ?? -1)?.toString(),
        (program_id ?? -1)?.toString(),
        isSupervisor
      )
      if (response) {
        const tableLayouts = response?.data?.filter(
          (item: { type: string }) => item?.type === 'Layout'
        )
        const tilesConfig = response?.data?.filter(
          (item: { type: string }) => item?.type === 'Tile'
        )

        const requestPayload: { program_id: string; user_id?: string } = {
          program_id: (program_id ?? -1)?.toString(),
        }

        if (
          selectedDashboard === DASHBOARD.AGENT_DASHBOARD &&
          !(
            profileCatergoryId === USER_PROFILE_CATEGORY.SYSTEM_ADMIN ||
            profileCatergoryId === USER_PROFILE_CATEGORY.PROGRAM_ADMIN
          )
        ) {
          requestPayload.user_id = (user_id ?? -1)?.toString()
        }

        const caseSummaryResponse = await getCaseSummaryTileAPI(requestPayload)

        if (caseSummaryResponse) {
          setTileConfig(
            tilesConfig
              ?.sort((a: { name: string }, b: { name: string }) => {
                const aName = a?.name?.toLocaleLowerCase()
                const bName = b?.name?.toLocaleLowerCase()

                if (aName.includes('intake')) return -1
                if (bName.includes('intake')) return 1
                return 0
              })
              ?.map(
                (item: {
                  name: string
                  dashboard_metadata: { queue_details: { queueId: number }[] }[]
                }) => {
                  const caseKey = item?.name?.toLowerCase()
                  const mergeCaseKey = caseKey.replace(/ /g, '_')
                  const caseData = caseSummaryResponse?.data?.[mergeCaseKey]
                  if (!caseData) return null

                  return {
                    caseName: item?.name,
                    intakes: caseData?.total ?? 0,
                    onTrack: caseData?.on_track ?? 0,
                    atRisk: caseData?.at_risk ?? 0,
                    overdue: caseData?.overdue ?? 0,
                    queueId:
                      item?.dashboard_metadata?.[0]?.queue_details?.[0]
                        ?.queueId,
                    onHyperlinkClick: onHyperlinkClick,
                  }
                }
              )
              ?.filter((item: DataTypeStore) => !!item)
          )
        }

        setTableLayoutConfig(
          tableLayouts?.map(
            (item: {
              layout_id: number
              entity_id: number
              name: string
              id: number
              dashboard_metadata: DashboardMetadata[]
            }) => ({
              layoutId: item?.layout_id ?? -1,
              entityId: item?.entity_id ?? -1,
              tableHeading: item?.name,
              programId: (program_id ?? -1)?.toString(),
              userId: (user_id ?? -1)?.toString(),
              dashboardId: item?.id ?? -1,
              entityName: item?.dashboard_metadata?.[0]?.entity_name ?? '',
              queueId:
                item?.dashboard_metadata?.[0]?.queue_details?.[0]?.queueId,
              queueDetails: item?.dashboard_metadata?.[0]?.queue_details,
            })
          )
        )
      }
      setHasTileData(true)
    } catch (err) {
      setHasTileData(false)
      console.error('Err :', err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchProgramWiseQueues = async (val: number) => {
    try {
      dispatch(showLoader())
      const payload = {
        filter: {
          fields: null,
          search_criteria: [
            {
              search_key: 'QUEUE_PROGRAMS',
              search_value: [val?.toString()],
              operator: 'IN',
            },
          ],
        },
        page: 0,
        size: 1000,
      }
      const response = await dashboardPageableQueuesApi(payload)
      if (response) {
        const programId = `${selectedClientProgram?.program_id ?? 0}`

        const hasCaseQueuePermission = (queue: FieldValues) => {
          const services =
            queue?.related_entities?.services?.filters?.[0]?.criteria?.[0]
              ?.values
          return services?.length
            ? services.some((service: string) =>
                permissionObject.Queue_Review_Manage(
                  programPermissions,
                  programId,
                  service
                )
              )
            : true
        }

        const hasIntakeQueuePermission = () =>
          permissionObject.Queue_Review_Manage_Intake(
            programPermissions,
            PERMISSION_MODULES.INTAKE_TRIAGE,
            PERMISSION_ACCESSIBILITY.MANAGE,
            programId
          )

        const hasQueuePermission = (queue: FieldValues) =>
          queue?.entity_name === ENTITY_NAME.CASE_LOWER
            ? hasCaseQueuePermission(queue)
            : hasIntakeQueuePermission()

        const mapQueueToOption = (item: FieldValues) => ({
          label: item?.name,
          value: item?.id?.toString(),
          entity_name: item?.entity_name,
          entity_id: item?.entity_id?.toString(),
          layout_id: item?.layout_id?.toString(),
          key: item?.id?.toString(),
          enabled: item?.enabled,
        })

        const programWiseQueueOptions = response?.data?.content
          ?.filter(hasQueuePermission)
          ?.map(mapQueueToOption)
          ?.filter((item: queueListingType) => item.enabled)

        const queuesWithNoPrograms = queueConfig
          ?.filter(hasQueuePermission)
          ?.filter(
            (item) =>
              item?.queue_programs?.length === 0 &&
              item?.enabled &&
              item?.name !== NAMESPACES.MY_CASES &&
              item?.name !== NAMESPACES.MY_TASKS
          )

        const queueOptionsWithoutPrograms =
          queuesWithNoPrograms.map(mapQueueToOption)
        const combinedOptions = [
          ...queueOptionsWithoutPrograms,
          ...programWiseQueueOptions,
        ]?.sort((a: CreateType, b: CreateType) =>
          a.label.toLowerCase().localeCompare(b.label.toLowerCase())
        )
        setProgramQueueOptions(combinedOptions)
      }
    } catch (err) {
      console.error('Err :', err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const onHyperlinkClick = (
    queueId: number,
    name: string,
    filter?: string,
    users_id?: string
  ) => {
    const queryParams = new URLSearchParams({
      name,
      filter: filter ?? '',
      programId: selectedClientProgram?.program_id?.toString() ?? '',
    })

    if (users_id) {
      queryParams.append('users_id', users_id)
    }

    const queryString = queryParams.toString()
    window.open(`/queue/${queueId}?${queryString}`, '_blank')
  }

  const getNoWorkLeftMessage = (selectedQueue: string | undefined) => {
    return selectedQueue !== DYNAMIC_QUEUE_CONSTANTS.INTAKE_UPPERCASE
      ? DYNAMIC_QUEUE_MESSAGES.CASE_UNAVAILABLE
      : DYNAMIC_QUEUE_MESSAGES.INTAKE_UNAVAILABLE
  }
  const getAssignedQueueConfigValue = (idType: string) => {
    if (idType === 'intake_id') {
      return DYNAMIC_QUEUE_CONSTANTS.INTAKE_LOWERCASE
    }
    if (idType === 'case_id') {
      return ENTITY_NAME.CASE_LOWER
    }
    return DYNAMIC_QUEUE_CONSTANTS.WEB_LOWERCASE
  }

  const getWorkAgents = async (
    queue_id: string,
    entity_name: string,
    entity_id: string,
    layout_id: string
  ) => {
    try {
      dispatch(showLoader())
      let serviceNames: string[] = []
      if (
        !isSuperAdmin() &&
        entity_name?.toLowerCase() === ENTITY_NAME.CASE_LOWER
      ) {
        serviceNames =
          programPermissionsObject.Queue_Get_Work_Services(programPermissions)
      }
      if (
        !isSuperAdmin() &&
        entity_name?.toLowerCase() !== ENTITY_NAME.CASE_LOWER
      ) {
        serviceNames = ['Benefit Verification']
      }
      const response = await getOldestWorkForAgentAPI(
        Number(queue_id),
        Number(userId),
        serviceNames,
        programServices
      )
      if (response) {
        const [message, details] = response?.data?.message?.split('{') ?? []
        const isWorkAssigned = !message?.startsWith('No')

        if (isWorkAssigned && details) {
          const cleanedDetails = details.replace('}', '').trim()
          const match = cleanedDetails.match(
            /(case_id|intake_id|enrollment_id)\s*:\s*([\w-]+),\s*id\s*:\s*(\d+)/
          )
          const idType = match[1]
          const caseId = match[2] ?? ''
          const id = match[3] ?? ''
          const assignedQueueConfig = getAssignedQueueConfigValue(idType)

          const successMessage = `${DYNAMIC_QUEUE_MESSAGES.ASSIGNED_NEW_WORK} ${assignedQueueConfig}: ${caseId}`
          dispatch(
            addToaster({
              id: uuid(),
              message: successMessage,
              type: 'success',
            })
          )

          if (idType === 'case_id') {
            await assignUnassignTasksWithCases(
              [id],
              user as DropdownType<string> | null
            )
            openNewWindow(
              `/entity/${entity_id}/workflow/review/${id}?message=${encodeURIComponent(
                successMessage
              )}`
            )
          } else if (idType === 'enrollment_id') {
            navigate(
              `/manage-queue/dynamic-queue/${entity_id}/${layout_id}/${queue_id}/${id}/${entity_id}/hcp`
            )
          } else {
            navigate(
              `/manage-queue/dynamic-queue/${entity_id}/${layout_id}/${queue_id}/${id}/${caseEntityId}`
            )
          }
        } else {
          const noWorkLeft = getNoWorkLeftMessage(selectedQueue)

          dispatch(
            addToaster({
              id: uuid(),
              message: noWorkLeft,
              type: 'error',
            })
          )
        }
      }
      dispatch(hideLoader())
    } catch (err) {
      const errorMessage =
        (err as AxiosError<ErrorResponseData>).response?.data?.message ?? ''
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const hasAgentDashBoardPermission = () => {
    const hasPermission = permissionObject.Manage_Dashboard(
      programPermissions,
      PERMISSION_MODULES.AGENT_DASHBOARD,
      PERMISSION_ACCESSIBILITY.MANAGE,
      selectedClientProgram?.program_id?.toString() ?? ''
    )
    return (
      isSuperAdmin() || isProgramAdmin() || isReadOnlyUser() || hasPermission
    )
  }

  const hasSupervisorDashBoardPermission = () => {
    const hasPermission = permissionObject.Manage_Dashboard(
      programPermissions,
      PERMISSION_MODULES.SUPERVISOR_DASHBOARD,
      PERMISSION_ACCESSIBILITY.MANAGE,
      selectedClientProgram?.program_id?.toString() ?? ''
    )
    return (
      isSuperAdmin() || isProgramAdmin() || isReadOnlyUser() || hasPermission
    )
  }

  const fetchQueueIdsandTableLayouts = useMemo(
    () =>
      debounce(
        async (
          callKey: string,
          selectedClientProgram: SelectedClientProgramType | null,
          allClientPrograms: ClientProgramsMap | null,
          userId: number | undefined,
          selectedDashboard: string
        ) => {
          if (!selectedClientProgram?.program_id || !allClientPrograms) return
          lastCallRef_1.current = callKey
          if (!isInteractiveDashboard) {
            await fetchTileAndLayoutConfig(
              (userId ?? -1).toString(),
              String(selectedClientProgram.program_id),
              selectedDashboard === DASHBOARD.SUPERVISOR_DASHBOARD,
              selectedDashboard
            )
          }
        },
        100
      ),
    []
  )

  useEffect(() => {
    setSelectedDashboard('agent')
    const agentPermission = hasAgentDashBoardPermission()
    const supervisorPermission = hasSupervisorDashBoardPermission()
    setHasDashboardsPermission(agentPermission && supervisorPermission)
  }, [selectedClientProgram, programPermissions])

  useEffect(() => {
    const interval = setInterval(() => {
      setRefetchKey((prev) => prev + 1)
    }, 1500000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    const fetchCaseId = async () => {
      const caseEntityData = await fetchEntityIdByName(
        dispatch,
        ENTITY_NAME.CASE_LOWER
      )

      dispatch(selectedCaseEntityReducer(caseEntityData?.id))
      setCaseEntityId(caseEntityData?.id)
    }
    if (!isInteractiveDashboard) {
      fetchCaseId()
    }
  }, [selectedTenantId])

  // will run only for agent dashboard
  useEffect(() => {
    const allClientProgramsCount = allClientPrograms
      ? Object.keys(allClientPrograms).length
      : 'no-programs'

    const callKey = `${
      selectedClientProgram?.program_id
    }-${allClientProgramsCount}-${
      Object.keys(programPermissions || {}).length
    }-${queueConfig?.length || 'no-config'}-${refetchKey}`

    if (lastCallRef.current === callKey) {
      return
    }

    if (
      allClientPrograms &&
      (!isEmpty(programPermissions) || isSuperAdmin() || isProgramAdmin()) &&
      selectedClientProgram?.program_id &&
      queueConfig?.length
    ) {
      lastCallRef.current = callKey
      if (!isInteractiveDashboard) {
        fetchProgramWiseQueues(selectedClientProgram.program_id)
      }
    }
  }, [
    refetchKey,
    selectedClientProgram,
    allClientPrograms,
    programPermissions,
    queueConfig,
  ])

  useEffect(() => {
    const callKey = `${selectedTenantName}-${
      selectedClientProgram?.program_id
    }-${selectedDashboard === DASHBOARD.AGENT_DASHBOARD}-${refetchKey}`
    if (lastCallRef_1.current === callKey) return
    fetchQueueIdsandTableLayouts(
      callKey,
      selectedClientProgram,
      allClientPrograms,
      userId,
      selectedDashboard
    )
    setIsSupervisor(selectedDashboard === DASHBOARD.SUPERVISOR_DASHBOARD)
  }, [refetchKey, selectedClientProgram, allClientPrograms, selectedDashboard])

  useEffect(() => {
    setHasData(!_.isEmpty(allClientPrograms))
  }, [allClientPrograms])

  useEffect(() => {
    dispatch(setProgramDropdown({ isVisible: true }))
  }, [location])

  return (
    <div className="flex flex-col w-full h-full relative z-0">
      {!isInteractiveDashboard && (
        <div className="sticky top-0 z-20 bg-white border-b border-gray-200 px-2 py-3">
          <div className=" flex justify-between items-center h-[2rem] w-full font-primary font-medium leading-5 text-md">
            <span>
              {selectedDashboard === DASHBOARD.AGENT_DASHBOARD
                ? `${DASHBOARD.AGENT}`
                : `${DASHBOARD.SUPERVISOR}`}
            </span>
            <div className="flex items-center justify-center gap-6">
              <div className={`flex items-center justify-center gap-6`}>
                {(profile === USER_PROFILES.STANDARD_USER ||
                  profile === USER_PROFILES.SUPERADMIN ||
                  profile === USER_PROFILES.PROGRAM_ADMIN) &&
                  selectedDashboard === DASHBOARD.AGENT_DASHBOARD && (
                    <>
                      <TemplateDropDown
                        options={programQueueOptions}
                        name="Get Work"
                        placeholder="Get Work"
                        onChange={(e) => {
                          getWorkAgents(
                            e?.key,
                            e?.entity_name ?? '-1',
                            e?.entity_id ?? '-1',
                            e?.layout_id ?? '-1'
                          )
                        }}
                        className="bg-primary-500 w-full"
                        defaultValue=""
                        widthForOptions="w-fit"
                        dataQaId="dropdown-template-listing"
                      />
                      <div className="flex">
                        <SvgVerticalSplitter />
                      </div>
                    </>
                  )}
              </div>
              {hasDashboardsPermission ? (
                <div className="relative flex bg-secondary-25 rounded-[2.27rem] py-0.5 px-1 gap-0.5">
                  <div
                    className={`absolute top-0.5 bottom-0.5 w-[50%] rounded-[2rem] bg-secondary-500 transition-all duration-300 ease-in-out ${
                      selectedDashboard === DASHBOARD.SUPERVISOR_DASHBOARD
                        ? 'left-1/2'
                        : 'left-0'
                    }`}
                  ></div>
                  <div
                    className={`relative z-10 transition-colors duration-300 text-xs py-2 px-8.5 rounded-[2.3rem] cursor-pointer ${
                      selectedDashboard === DASHBOARD.AGENT_DASHBOARD
                        ? 'text-white'
                        : 'text-border-50'
                    }`}
                    onClick={() =>
                      setSelectedDashboard(DASHBOARD.AGENT_DASHBOARD)
                    }
                  >
                    {DASHBOARD.AGENT}
                  </div>
                  <div
                    className={`relative z-10 transition-colors duration-300 text-xs py-2 px-6 rounded-[2.3rem] cursor-pointer ${
                      selectedDashboard === DASHBOARD.SUPERVISOR_DASHBOARD
                        ? 'text-white'
                        : 'text-border-50'
                    }`}
                    onClick={() =>
                      setSelectedDashboard(DASHBOARD.SUPERVISOR_DASHBOARD)
                    }
                  >
                    {DASHBOARD.SUPERVISOR}
                  </div>
                </div>
              ) : null}
              <button
                className="cursor-pointer flex p-1"
                onClick={handleReloadButtonClick}
              >
                <SvgReload />
              </button>
            </div>
          </div>
        </div>
      )}
      <div className={`flex-grow ${isInteractiveDashboard ? '' : 'pb-4'}`}>
        {!hasData ? (
          <span className="font-primary leading-6 text-xs px-2 py-3 flex items-center mt-4">
            {NAMESPACES.NO_ACTIVE_PROGRAM_VALIDATION_MSG}
          </span>
        ) : (
          <div className="flex flex-col gap-4">
            {isInteractiveDashboard ? (
              <InteractiveDashboard />
            ) : !hasTileData ? (
              <span className="font-primary leading-6 text-xs px-2 py-3 flex items-center">
                {STRINGS.DASHBOARD_TILE_VERBIAGE}
              </span>
            ) : (
              <div>
                {tileConfig?.length > 0 && (
                  <div className="flex ">
                    <Carousel
                      items={tileConfig}
                      renderItem={(data, index) => (
                        <CaseTile
                          key={index}
                          {...data}
                          onHyperlinkClick={onHyperlinkClick}
                          selectedDashboard={selectedDashboard}
                        />
                      )}
                      showScrolls={true}
                    />
                  </div>
                )}
                <div
                  key={selectedDashboard}
                  className="grid grid-cols-2  w-full h-full "
                >
                  {tableLayoutConfig?.map((item) => (
                    <div className={'col-span-2 mt-1'} key={item?.dashboardId}>
                      <DynamicLayoutTable
                        key={
                          selectedClientProgram?.tenant_id +
                          '-' +
                          selectedClientProgram?.program_id
                        }
                        layoutId={item?.layoutId ?? '-1'}
                        entityId={item?.entityId ?? '-1'}
                        programId={item?.programId ?? '-1'}
                        dashboardId={item?.dashboardId ?? '-1'}
                        tableHeading={item?.tableHeading}
                        isSupervisor={isSupervisor}
                        userId={item?.userId ?? '-1'}
                        tenantId={item?.tenantId ?? '-1'}
                        refetchKey={refetchKey}
                        entityName={item?.entityName}
                        queueId={item?.queueId}
                        onHyperLinkClick={onHyperlinkClick}
                        queueDetails={item?.queueDetails}
                        selectedDashboard={selectedDashboard}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export const CaseTile = ({
  caseName,
  intakes,
  onTrack,
  atRisk,
  overdue,
  queueId,
  onHyperlinkClick,
  selectedDashboard,
}: CaseTileDataType) => {
  const userId = useAppSelector((state: RootState) => state?.authUser?.user?.id)
  const userIdValue =
    selectedDashboard === DASHBOARD.AGENT_DASHBOARD
      ? userId?.toString()
      : undefined
  return (
    <div className="flex p-4 flex-col w-fit rounded shadow-[6px_6px_54px_0px_rgba(0,0,0,0.05)] min-w-fit border">
      <div className="flex flex-col">
        <div className="flex">
          <div
            className="flex flex-col pr-2"
            style={{ minWidth: `${(caseName?.length ?? 2) * 0.5}rem` }}
          >
            <span className="text-xs leading-5 font-primary font-normal text-accent-900">
              {caseName}
            </span>
            <button
              onClick={() =>
                intakes &&
                onHyperlinkClick(queueId, caseName, undefined, userIdValue)
              }
              className="flex items-center justify-start text-secondary-500 rounded font-normal text-[1.25rem] leading-8"
            >
              {intakes}
            </button>
          </div>
          <div className="border-l flex mx-3 border-l-accent-300"></div>
          <div className="flex gap-3">
            <TileItem
              onTileChange={() =>
                onTrack &&
                onHyperlinkClick(queueId, caseName, 'ON_TRACK', userIdValue)
              }
              label="On Track"
              value={onTrack}
              bg="bg-green-100"
            />
            <TileItem
              onTileChange={() =>
                atRisk &&
                onHyperlinkClick(queueId, caseName, 'AT_RISK', userIdValue)
              }
              label="At Risk"
              value={atRisk}
              bg="bg-yellow-100"
            />
            <TileItem
              onTileChange={() =>
                overdue &&
                onHyperlinkClick(queueId, caseName, 'OVERDUE', userIdValue)
              }
              label="Overdue"
              value={overdue}
              bg="bg-red-100"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

const TileItem = ({
  label,
  value,
  bg,
  onTileChange,
}: {
  label: string
  value: number
  bg: string
  onTileChange?: () => void
}) => (
  <button
    onClick={onTileChange}
    className="flex flex-col items-start w-auto gap-2"
    tabIndex={value ? 0 : -1}
  >
    <span className="text-xs leading-5 font-primary font-normal text-accent-600">
      {label}
    </span>
    <span
      className={`w-10 h-[1.625rem] flex items-center justify-center ${bg} rounded text-xs`}
    >
      {value}
    </span>
  </button>
)

export default DashboardPage
